// extracted by mini-css-extract-plugin
export var contentBody = "_c3-9";
export var headerImage = "_c3-2";
export var imageButton = "_c3-7";
export var imageButtonIcon = "_c3-8";
export var imageHeader = "_c3-4";
export var imageHeaderText = "_c3-5";
export var imageOverlay = "_c3-3";
export var imageTitle = "_c3-6";
export var imageWrapper = "_c3-1";
export var taskList = "_c3-a";
export var widget = "_c3-0";